export enum OrganizationTableColumns {
  name = "name",
  organizationType = "organizationType",
  stytchOrganizationId = "stytchOrganizationId",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
  clientCount = "clientCount",
  userCount = "userCount",
  employeeCount = "employeeCount",
}

export const ORGANIZATION_TABLE_COLUMN_LABELS: Record<
  OrganizationTableColumns,
  string
> = {
  [OrganizationTableColumns.name]: "Name",
  [OrganizationTableColumns.organizationType]: "Type",
  [OrganizationTableColumns.stytchOrganizationId]: "Stytch ID",
  [OrganizationTableColumns.clientCount]: "Clients",
  [OrganizationTableColumns.userCount]: "Users",
  [OrganizationTableColumns.employeeCount]: "Employees",
  [OrganizationTableColumns.createdAt]: "Created",
  [OrganizationTableColumns.updatedAt]: "Updated",
};

export const DEFAULT_ORGANIZATION_TABLE_COLUMN_ORDER: OrganizationTableColumns[] =
  [
    OrganizationTableColumns.name,
    OrganizationTableColumns.organizationType,
    OrganizationTableColumns.stytchOrganizationId,
    OrganizationTableColumns.clientCount,
    OrganizationTableColumns.userCount,
    OrganizationTableColumns.employeeCount,
    OrganizationTableColumns.createdAt,
    OrganizationTableColumns.updatedAt,
  ];

export const DEFAULT_ORGANIZATION_TABLE_COLUMN_SETTINGS: Record<
  OrganizationTableColumns,
  boolean
> = {
  [OrganizationTableColumns.name]: true,
  [OrganizationTableColumns.organizationType]: true,
  [OrganizationTableColumns.stytchOrganizationId]: true,
  [OrganizationTableColumns.clientCount]: true,
  [OrganizationTableColumns.userCount]: true,
  [OrganizationTableColumns.employeeCount]: true,
  [OrganizationTableColumns.createdAt]: true,
  [OrganizationTableColumns.updatedAt]: false,
};
